<mf-page title="Detalles de la conciliación">
  @if(conciliation) {
  <mf-column-display label="Id">{{ conciliation.id }}</mf-column-display>
  }
</mf-page>
